import { createContext, useContext, useState } from "react";

import PropTypes from "prop-types";
import api from "../config/api";
import { toast } from "react-toastify";

export const HelpAndSupportContext = createContext();

export const HelpAndSupportProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const needSupport = async (request) => {
    setLoading(true);
    try {
      const response = await api.needSupport.createSupport(request);
      if (response?.success) {
        setLoading(false);
        toast.success(response?.message);
      }
      return response;
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const reportAnIssue = async (request) => {
    setLoading(true);
    try {
      const response = await api.reportIssue.createReportAnIssue(request);
      if (response?.success) {
        toast.success(response?.message);
      }
      return response;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      setLoading(false);
    }
  };
  const reachUs = async (request) => {
    setLoading(true);
    try {
      const response = await api.reachUs.createReachUs(request);
      if (response?.success) {
        setLoading(false);
        toast.success(response?.message);
      }
      return response;
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      setLoading(false);
    }
  };

  const contextValue = {
    loading,
    needSupport,
    reportAnIssue,
    reachUs
  };
  return (
    <HelpAndSupportContext.Provider value={contextValue}>
      {children}
    </HelpAndSupportContext.Provider>
  );
};

HelpAndSupportProvider.propTypes = {
  children: PropTypes.node,
};

export const useHelpAndSupport = () => useContext(HelpAndSupportContext);
